/**
 * @ngdoc config
 * @memberof mercury.startup
 * @name ApplicationConfig
 * @description Set some of the configs for the applcation
 */
angular.module('mercury.startup')
.config(["$compileProvider", "$httpProvider", "$stateProvider", "$urlRouterProvider", "settings", "$resourceProvider", function($compileProvider, $httpProvider, $stateProvider, $urlRouterProvider, settings, $resourceProvider) {

  // write the values from the settings into the window object so they can be
  // accessed by the React app.
  window.__Loaded = window.__Loaded || {};
  Object.assign(window.__Loaded, {
    apiUrl: settings.apiHost,
    mercuryApiUrl: settings.mercHost,
    stockApiUrl: settings.stockHost,
  });

  //Enable the http interceptor for authentication=, and other errors, redirect
  $httpProvider.interceptors.push('errorInterceptor');
  $httpProvider.interceptors.push('httpThrottler');

  //Add a default action to ngResource for updating with a PUT HTTP action
  $resourceProvider.defaults.actions.update = {method: 'PUT'};

  //The default route
  $stateProvider.state('Blank', {
    url: '/'
  });

  // OAuth redirect route
  $stateProvider.state('FullScreen.Connections', {
    url: '/connections?:system&:code&:scope'
  });
  $stateProvider.state('FullScreen.RequestEmployeeInformation', {
    url: '/employee/request-information'
  });

  // Disable the default route handling so that we can defer it until after
  // we have setup a custom $locationChange listener that ensures that the
  // React app is aware of AngularJS navigation events. See the listener in
  // app/startup/statechangelisteners.run.js for more details.
  $urlRouterProvider.deferIntercept();

  $urlRouterProvider.otherwise('/');

  // Disabling debugInfo improves performance. See https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(settings.debug === 'true');

  // Handle progressive styling upgrades that users can opt into via using the
  // the following urls:
  //
  // Alpha styling - /App?alpha-ui#/reports/dashboard
  // Beta styling - /App?beta-ui#/reports/dashboard
  //
  // Or to opt back out of these and go back to the default styling:
  //
  // Reset styling - /App?reset-ui#/reports/dashboard

  if (window.location.search.includes('alpha-ui')) {
    window.localStorage.setItem('@@loaded/alpha-styles', true);
    window.localStorage.removeItem('@@loaded/alpha-styles-no-icons');
  }

  if (window.location.search.includes('beta-ui')) {
    window.localStorage.setItem('@@loaded/beta-styles', true);
  }

  if (window.location.search.includes('alpha-ui-no-icons')) {
    window.localStorage.setItem('@@loaded/alpha-styles-no-icons', true);
  }

  if (window.location.search.includes('reset-ui')) {
    window.localStorage.removeItem('@@loaded/alpha-styles');
    window.localStorage.removeItem('@@loaded/alpha-styles-no-icons');
    window.localStorage.removeItem('@@loaded/beta-styles');
  }

  function injectStyleSheet(url) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css'
    link.href = url;
    document.head.appendChild(link);
  }

  // If there is a style overrides key set (which we expect someone to do manually to test this
  // out), then pull in the style overrides file.
  if (window.localStorage.getItem('@@loaded/alpha-styles')) {
    injectStyleSheet('/App/css/app-alpha-styles.css');
  } else if (window.localStorage.getItem('@@loaded/beta-styles')) {
    injectStyleSheet('/App/css/app-beta-styles.css');
  }
}]);
